export default "__VITE_ASSET__D5YVm8I1__"